import {
	requests
}from "../../api/agent"

export default {
	uploadFiles          : (params) => requests.post("/uploadFile", params),
	deleteFiels          : (params) => requests.post("/uploadFile/deleteFiels", params),
	deleteAppealOrgFile  : (params) => requests.post("/uploadFile/deleteAppealOrgFile", params),
	deleteResolutionFile : (params) => requests.post("/uploadFile/deleteResolutionFile", params)
}